let modalCount = 0;
let scrollPosition = 0;

export function DisableScroll() {

    modalCount++;

    // only lock on first modal
    if (modalCount > 1) return;

    scrollPosition = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
}

export function EnableScroll() {
    
    if (modalCount > 0) modalCount--;
    
    // only unlock when last modal closes
    if (modalCount > 0) return;
    
    const top = document.body.style.top;

    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("left");
    document.body.style.removeProperty("right");
    document.body.style.removeProperty("width");

    window.scrollTo(0, Math.abs(parseInt(top || "0")));
}